import React, { forwardRef, useImperativeHandle } from 'react';

import Labels from "../../../assets/labels";
import { Controller, useFormContext } from 'react-hook-form';
import { CheckboxGroup, useLang } from '@manulife/mux';
import { isObjectEmpty } from '../../../services/helpers/objectUtilities';

import './style/RtgSynChildInsuredType.css';

const RtgSynChildInsuredType = forwardRef(({ chIndex }, ref) => {
    const fieldName = `rtgSynChilds.${chIndex}.insuredTypes`;
    const focusInsuranceField = () => {
        // focus on first button 
        document.getElementById(`${fieldName}-LifeInsurance10k`)?.focus();
    };

    useImperativeHandle(ref, () => ({
        focus: focusInsuranceField
    }));


    const selectedLang = useLang();
    const { control } = useFormContext(); // retrieve all hook methods
    return (
        <>
            <Controller
                control={control}
                name={fieldName}
                rules={{
                    required: Labels.errors.childInsuranceType[`${selectedLang}`],
                    validate: (value) => {
                        if (!value?.CriticalIllness && !value?.LifeInsurance10k && isObjectEmpty(value)) {
                            return Labels.errors.childInsuranceType[`${selectedLang}`];
                        }
                        return null;
                    }
                }}
                render={({
                    field: { onChange, onBlur, value, name },
                    fieldState: { error },
                }) => (
                    <>
                        <CheckboxGroup
                            id={name}
                            values={Labels.insuredTypes[`${selectedLang}`].options}
                            aria-required={true}
                            selected={value}
                            onBlur={onBlur}
                            onChange={onChange}
                            errors={error ? [error.message] : undefined}
                            callouts={false}
                        />
                    </>
                )}
            />
        </>
    )
});

export default RtgSynChildInsuredType;